import { extractTopconCustomerNumber } from '../../../../utils/utils';
import { formatOrganizationNumber } from '../../../../utils/organizationNumberFormatter';
import { UNKNOWN_VALUE } from '../constants';
import CellText from './CellText';

export interface OrganizationNumberCellProps {
  /** `BusinessPartnerBody.extId`, a `urn:...:<12 digits>:bp` URN. */
  extId: string | undefined;
}

/**
 * Organization no. cell (PRD D7): `customer.extId` →
 * `extractTopconCustomerNumber` → `formatOrganizationNumber`. Shared by
 * Customers (02), Invites (03) and Requests › Join (04). Pair with the
 * `customersTable.tooltipOrganizationNumber` i18n key as the column
 * header's ⓘ tooltip (`ServerPagedTableColumn.headerInfoTooltip`).
 */
export default function OrganizationNumberCell({ extId }: OrganizationNumberCellProps) {
  const number = extId ? extractTopconCustomerNumber(extId) : undefined;
  return <CellText text={number ? formatOrganizationNumber(number) : UNKNOWN_VALUE} />;
}
